// extracted by mini-css-extract-plugin
export default {"icon-button-wrapper":"aWjg4","iconButtonWrapper":"aWjg4","number":"_1Vg3w"};